<header class="h-21 bg-[#333333] flex items-center justify-between px-6 shadow-md relative z-10 w-full text-white">

    <!-- Left: Branding -->
    <div class="flex items-center gap-4 cursor-pointer select-none" routerLink="/management/dashboard" (click)="onLogoClick()">
        <img src="logo.png" alt="EverBrite Logo" class="h-8 w-auto">
        <h1 class="text-white">永彰智慧辦公室系統</h1>
    </div>

    <!-- Right: Time and Actions -->
    <div class="flex items-center gap-4">
        <!-- MQTT Connection Status (Developer Only) -->
        @if (isDeveloper()) {
            <div [title]="(mqttService.isConnected$ | async) ? 'MQTT 已連線' : 'MQTT 已斷線'"
                class="text-xs font-normal tracking-wide bg-white/10 px-3 py-1.5 rounded flex items-center gap-2 border border-white/20 select-none">
                <span class="flex h-2.5 w-2.5 relative">
                    @if (mqttService.isConnected$ | async) {
                        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                    }
                    <span class="relative inline-flex rounded-full h-2.5 w-2.5"
                          [ngClass]="(mqttService.isConnected$ | async) ? 'bg-green-500' : 'bg-red-500'"></span>
                </span>
                <span class="font-bold text-white/90">MQTT</span>
            </div>

            <!-- 自動登出倒數 -->
            <div class="text-xs font-normal tracking-wide bg-white/10 px-3 py-1.5 rounded flex items-center gap-2 border border-white/20 select-none"
                 title="自動登出倒數">
                <i class="pi pi-hourglass text-[10px]"></i>
                <span class="font-bold text-white/90">登出倒數: {{ authService.logoutCountdownFormatted() }}</span>
            </div>
        }

        <!-- Current Time display -->
        <div
            class="text-sm font-normal tracking-wide bg-white/10 px-4 py-1.5 rounded flex items-center gap-2 border border-white/20">
            <i class="pi pi-clock text-xs"></i> 系統時間 : {{ systemTimeService.currentTime() | date:'yyyy-MM-dd HH:mm' }}
        </div>

        <!-- Notification Popover -->
        <p-button styleClass="w-9 h-9 p-0 flex justify-center items-center !overflow-visible"
            (onClick)="onBellClick($event, op)" ariaLabel="通知">
            <ng-template #icon>
                @if (unresolvedCount() > 0) {
                    <p-overlaybadge [value]="unresolvedCount().toString()" severity="danger" styleClass="text-[10px]">
                        <i class="pi pi-bell text-lg"></i>
                    </p-overlaybadge>
                } @else {
                    <i class="pi pi-bell text-lg"></i>
                }
            </ng-template>
        </p-button>
        <!-- Hamburger Menu -->
        <p-button icon="pi pi-bars" styleClass="w-9 h-9 p-0 flex justify-center items-center"
            (onClick)="toggleMenu.emit()"></p-button>

        <p-popover #op styleClass="p-0 border-0 shadow-lg mt-2 overflow-hidden rounded-lg">
            <div class="w-80 flex flex-col bg-white">
                <!-- Header -->
                <div class="flex justify-between items-center p-3 bg-orange-50/80 border-b border-gray-200">
                    <div class="flex items-center gap-2 text-gray-800 font-bold text-base">
                        <i class="pi pi-bell text-red-500 font-bold"></i>
                        <span>最新告警</span>
                    </div>
                    <div class="bg-red-500 text-white text-xs px-2 py-1 rounded-md">
                        {{ unresolvedCount() }} 筆未結案
                    </div>
                </div>

                <!-- List Content -->
                <div class="flex flex-col max-h-[350px] overflow-y-auto">
                    <!-- Empty -->
                    @if (alarms().length === 0) {
                        <div class="p-6 text-center text-gray-400 text-sm">
                            <i class="pi pi-check-circle text-2xl text-green-400 mb-2 block"></i>
                            目前無未結案告警
                        </div>
                    }
                    <!-- Item Loop -->
                    @for (alarm of alarms(); track alarm.alarmId) {
                        <div class="p-3 border-b border-gray-200 flex flex-col gap-2 hover:bg-gray-50 transition-colors">
                            <div class="flex flex-col gap-1">
                                <div class="flex justify-between items-start">
                                    <div class="flex flex-col gap-0.5">
                                        <span class="text-gray-900 font-bold text-base">{{ alarm.deviceName }}</span>
                                    </div>
                                    <div class="text-red-500 border border-red-400 bg-red-50/50 px-1.5 py-0.5 rounded text-xs">
                                        {{ alarm.status === 0 ? '未結案' : '已結案' }}
                                    </div>
                                </div>
                                <span class="text-gray-500 text-xs">{{ alarm.description }}</span>
                            </div>
                            <div class="flex items-center gap-3 text-gray-500 text-[12px] mt-1">
                                <div class="flex items-center gap-1">
                                    <i class="pi pi-map-marker text-[10px]"></i> {{ alarm.floorName }} · {{ alarm.spaceName
                                    }}
                                </div>
                                <div class="flex items-center gap-1">
                                    <i class="pi pi-clock text-[10px]"></i> {{ alarm.triggerTime | date:'yyyy-MM-dd HH:mm'
                                    }}
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <!-- Footer Action -->
                <div class="bg-gray-50 w-full">
                    <p-button label="查看更多告警紀錄" icon="pi pi-arrow-right" iconPos="right" class="w-full block"
                        styleClass="w-full" (onClick)="op.hide(); router.navigate(['/alerts'], { queryParams: { statuses: [0] } })"></p-button>
                </div>
            </div>
        </p-popover>
    </div>
</header>
